module.exports = __webpack_public_path__ + "static/media/gts25.aa9144aa.png";